export default "__VITE_ASSET__n2Ipnco2__"